import './anonymous.css'

import PropTypes from 'prop-types'
import React from 'react'

const AnonymousWrapper = ({ children }) => <div className="anonymous-page">{children}</div>

AnonymousWrapper.propTypes = {
  children: PropTypes.node,
}

export default AnonymousWrapper
